@if (items) {
  <div class="dropdown-toggle-none"
       #dropdown="ngbDropdown"
       [autoClose]="'outside'"
       (openChange)="dropdownOpenChange($event)"
       ngbDropdown>
    <button class="ws-filter-chip ws-filter-chip--dropdown"
            [class.ws-filter-chip--active]="isSelected"
            ngbDropdownToggle>{{placeholder}}
    </button>
    <div ngbDropdownMenu
         aria-labelledby="dropdownConfig"
         class="dd-menu ws-dropdown"
         [class.dd-close]="showCloseAnimation">
      @for (item of model; track item.value) {
        <ui-checkbox class="dropdown-item-checkbox font-sm ws-dropdown__item"
                     [model]="item.checked"
                     (modelChange)="itemModelChange(item, $event)">
          {{item.label}}
        </ui-checkbox>
      }
    </div>
  </div>
}
